import React from 'react';  
import { Alert, message } from 'antd';
import { useTranslation } from 'react-i18next';
import './alertComponent.scss';

interface AlertComponentProps {
  formErrors: string[];
  isShowError?: boolean;
}

const AlertComponent: React.FC<AlertComponentProps> = ({ formErrors, isShowError = false }) => {
  const { t } = useTranslation();
  return (
    <div className='alert-validation'>
      <Alert 
        showIcon
        message={
          <ul>
            <div>{t("common.please_correct_errors")}</div>
            {isShowError && formErrors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        }
        type="error"
        />
    </div>
  );
};

export default AlertComponent; 